import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const USER_ONBOARDING_DISABLE = gql(`
  mutation userOnboardingDisable {
    userOnboardingDisable {
      __typename
      id
      preferences {
        __typename
        onboardingDisabled
      }
    }
  }
`);

export function useUserOnboardingDisable() {
  return useMutation(USER_ONBOARDING_DISABLE);
}
